// TruncateHtml.jsx
import React, { useState, useRef, useEffect } from 'react';

// Ye component HTML content ko truncate karke "View More" / "View Less" button dikhata hai
export const TruncateHtml = ({ html, collapsedHeight = 80 }) => {
  const [expanded, setExpanded] = useState(false);
  const [needsToggle, setNeedsToggle] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (ref.current && !expanded) {
      if (ref.current.scrollHeight > collapsedHeight) setNeedsToggle(true);
    }
  }, [html, collapsedHeight, expanded]);

  return (
    <div>
      {/* Content container jiski height adjustable hai */}
      <div
        ref={ref}
        style={{
          maxHeight: expanded ? 'none' : `${collapsedHeight}px`,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
        }}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {/* Agar content overflow kare tabhi toggle button dikhega */}
      {needsToggle && (
        <button
          className="btn btn-link p-0"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? 'View Less' : 'View More'}
        </button>
      )}
    </div>
  );
};
